// @ts-nocheck
import { QueryClientProvider, useQuery } from "@tanstack/react-query";
import { queryClient } from "@/lib/query-client";
import { Toaster } from "@/components/ui/toaster";
import { FloatingChatWindow } from "@/components/chat/floating-chat-window";
import { FloatingChatProvider } from "@/contexts/floating-chat-context";

/**
 * Minimal popup page for a single chat space.
 * URL param: space_id
 * Renders FloatingChatWindow in a non-minimized, non-floating layout.
 */
function ChatPopupInner({ currentUserId }: { currentUserId?: string }) {
  const params = new URLSearchParams(window.location.search);
  const spaceId = params.get("space_id") ?? "";

  if (!spaceId) {
    return <div className="p-4 text-muted-foreground">No space selected.</div>;
  }

  return (
    <div className="flex flex-col h-screen bg-background overflow-hidden">
      <FloatingChatWindow
        spaceId={spaceId}
        index={0}
        isMinimized={false}
        currentUserId={currentUserId}
        popupMode
      />
    </div>
  );
}

function ChatPopupWithUser() {
  const { data: currentUser } = useQuery<{ id: string }>({
    queryKey: ["/api/auth/user"],
  });

  if (!currentUser) {
    return null;
  }

  return (
    <FloatingChatProvider userId={currentUser.id}>
      <ChatPopupInner currentUserId={currentUser.id} />
      <Toaster />
    </FloatingChatProvider>
  );
}

export function ChatPopupPage() {
  return (
    <QueryClientProvider client={queryClient}>
      <ChatPopupWithUser />
    </QueryClientProvider>
  );
}
